/**
 * Every executor a Conductor task can name, keyed by a readable name.
 *
 * The node definitions build tasks around these, and everything that later
 * reads a task back - execution summaries, the simulation, the approval
 * outcome - finds its task by the same value, so a rename on the backend is one
 * change here rather than a hunt through string literals.
 */
export const TASK_EXECUTORS = {
  cancelManualTask: 'cancel_manual_task',
  compareQuotePricing: 'compare_quote_pricing',
  createSchedule: 'create_schedule',
  customer: 'customer',
  extractContract: 'extract_contract',
  generateInvoiceReminder: 'generate_invoice_reminder',
  invoice: 'invoice',
  previousQuoteApproval: 'previous_quote_approval',
  publishQuote: 'publish_quote',
  quote: 'quote',
  quoteTemplate: 'quote_template',
  reviewContract: 'review_contract',
  reviewEmail: 'review_email',
  reviewQuote: 'review_quote',
  sendEmail: 'send_email',
  sendInvoiceReminder: 'send_invoice_reminder',
  user: 'user'
} as const
